import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combina clases resolviendo conflictos de Tailwind.
 *
 * `clsx` decide que clases entran; `twMerge` garantiza que la ultima gana
 * cuando dos compiten por la misma propiedad (por ejemplo `px-2` y `px-4`).
 * Sin el, el resultado dependeria del orden en la hoja de estilos, que no es
 * el orden en que se escriben aqui.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
